export class  recycleBinUrl  {
   DELETE_RECYCLE_BIN_RETURN_URL = "ssr/v2/recycle-bin-return/";
   RECYCLE_BIN_RETURN_URL = "ssr/v2/recycle-bin-return/all[?ClientName][&ClientId][&TaxYear][&EngagementType][&ERO][&SentBy][&DeliveredAfter][&Status][&DeletedOn][&DeletedBy][&PageNumber][&PageSize][&SortBy][&SortOrder]";
   RESTORE_RECYCLE_BIN_RETURN_URL = "ssr/v2/recycle-bin-return/restore";
}
